import { createFileRoute } from '@tanstack/react-router'
import { FoliosPage } from '@/features/hospitality/pages/FoliosPage'

export const Route = createFileRoute('/_app/hospitality/folios')({
  component: FoliosPage,
})
